"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTouchInput = void 0;
const ValueObjects_1 = require("../ValueObjects");
function makeTouchInput() {
    return new TouchInputImp();
}
exports.makeTouchInput = makeTouchInput;
class TouchInputImp {
    constructor() {
        this.controllers = [];
        this._eventElement = undefined;
        this.updateInputElementBounds = () => {
            if (!this._eventElement)
                return;
            this.eventElementBounds = this._eventElement.getBoundingClientRect(); // Expensive so we cache
        };
        this.getTouchOffsetPosition = (touch) => {
            if (!this.eventElementBounds) {
                console.warn("No target bounds");
                return ValueObjects_1.Vector2.Zero();
            }
            const x = touch.clientX - this.eventElementBounds.x;
            const y = touch.clientY - this.eventElementBounds.y;
            return new ValueObjects_1.Vector2(x, y);
        };
        this.setEventElement = (eventElement) => {
            if (this._eventElement)
                this.clearInputElement();
            eventElement.addEventListener("touchstart", this.onTouchStart, false);
            eventElement.addEventListener("touchmove", this.onTouchMove, false);
            eventElement.addEventListener("touchend", this.onTouchEnd, false);
            eventElement.addEventListener("touchcancel", this.onTouchCancel, false);
            this.eventElementBounds = eventElement.getBoundingClientRect();
            this._eventElement = eventElement;
        };
        this.onTouchStart = (e) => {
            if (e.cancelable)
                e.preventDefault();
            const touchInput = this.createTouchInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onTouchStart) {
                    c.onTouchStart(touchInput);
                }
            });
        };
        this.onTouchMove = (e) => {
            if (e.cancelable)
                e.preventDefault();
            const touchInput = this.createTouchInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onTouchMove) {
                    c.onTouchMove(touchInput);
                }
            });
        };
        this.onTouchEnd = (e) => {
            if (e.cancelable)
                e.preventDefault();
            const touchInput = this.createTouchInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onTouchEnd) {
                    c.onTouchEnd(touchInput);
                }
            });
        };
        this.onTouchCancel = (e) => {
            if (e.cancelable)
                e.preventDefault();
            const touchInput = this.createTouchInputEvent(e);
            this.controllers.forEach((c) => {
                if (c.onTouchCancel) {
                    c.onTouchCancel(touchInput);
                }
            });
        };
        this.clearInputElement = () => {
            if (!this._eventElement)
                return;
            this._eventElement.removeEventListener("touchstart", this.onTouchStart);
            this._eventElement.removeEventListener("touchmove", this.onTouchMove);
            this._eventElement.removeEventListener("touchend", this.onTouchEnd);
            this._eventElement.removeEventListener("touchcancel", this.onTouchCancel);
            this._eventElement = undefined;
        };
        this.registerController = (controller) => {
            this.controllers.push(controller);
        };
        this.removeController = (controller) => {
            const index = this.controllers.indexOf(controller);
            if (index >= 0) {
                this.controllers.splice(index, 1);
            }
        };
    }
    get eventElement() {
        return this._eventElement;
    }
    createTouchInputEvent(event) {
        const touches = [];
        const touchCount = event.touches.length;
        let minX = 0;
        let maxX = 0;
        let minY = 0;
        let maxY = 0;
        for (let i = 0; i < touchCount; i++) {
            const touch = event.touches[i];
            const position = this.getTouchOffsetPosition(touch);
            touches.push({
                id: touch.identifier,
                touch,
                position,
            });
            if (i === 0) {
                minX = position.x;
                maxX = position.x;
                minY = position.y;
                maxY = position.y;
            }
            else {
                minX = Math.min(minX, position.x);
                maxX = Math.max(maxX, position.x);
                minY = Math.min(minY, position.y);
                maxY = Math.max(maxY, position.y);
            }
        }
        let cntX = 0;
        let cntY = 0;
        if (touchCount === 1) {
            cntX = maxX;
            cntY = maxY;
        }
        else {
            cntX = minX + (maxX - minX) / 2;
            cntY = minY + (maxY - minY) / 2;
        }
        return {
            touchCenter: new ValueObjects_1.Vector2(cntX, cntY),
            touchCount,
            touches,
            event,
        };
    }
}
